import { connect } from 'react-redux';
import * as metaActions from '../../redux-modules/meta/actions.js';
import * as fieldsMetaActions from '../../redux-modules/fieldsMeta/actions.js';
import AppDataLoader from './AppDataLoader';

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(metaActions.loadMeta());
      dispatch(fieldsMetaActions.loadFieldsMeta());
    }
  };
}

export default connect(null, mapDispatchToProps)(AppDataLoader);
